
import { Options, Vue } from 'vue-class-component';
import CountryPicker from "@/components/CountryPicker.vue"
import NumberPicker from "@/components/NumberPicker.vue"
import DatePicker from "@vuepic/vue-datepicker"
import {Watch} from "vue-property-decorator";


@Options({
  components: {
    CountryPicker,
    DatePicker,
    NumberPicker,
  },
})
export default class App extends Vue {

  from = localStorage.getItem("tours_from") || "Москва";
  to = localStorage.getItem("tours_to") || "";
  start_date = new Date();
  adults_count = +localStorage.getItem("adults_count")! || 1;
  nights_count = +localStorage.getItem("nights_count")! || 7;

  mounted(){
    if(localStorage.getItem("start_date")){
      const date = +localStorage.getItem("start_date")!;
      if(date > +new Date()){
        this.start_date = new Date(date);
      }
    }
  }

  findTours(){
    this.$emit("submit",{
      "from": this.from,
      "to": this.to,
      "start_date": this.start_date,
      "adults_count": this.adults_count,
      "nights_count": this.nights_count,
    })
  }

  getRuMonth(index: number){
    return [
        "января","февравля","марта","апреля","мая","июня","июля","августа",
        "сентября","октября","ноября","декабря"
    ][index];
  }

  formatDate(date: Date){
    return date.getDate() + ' ' + this.getRuMonth(date.getUTCMonth()) + ' ' + date.getFullYear() + 'г.'
  }

  @Watch("start_date")
  writeStartDate(value: Date){
    console.log(value);
    localStorage.setItem("start_date",(+value).toString());
  }

  writeAdultsCount(value: number){
    localStorage.setItem("adults_count",value.toString());
  }

  writeNightsCount(value: number){
    localStorage.setItem("nights_count",value.toString());
  }

  writeFrom(value: string){
    localStorage.setItem("tours_from",value);
  }

  writeTo(value: string){
    localStorage.setItem("tours_to",value);
  }
}
